import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ApiError, BaseVisualizacao, BaseVisualizacaoService, DataTablesService, MessageService } from '../../core';
import { ItemUnidadeCrudHttpService } from './services';

import { ItemUnidade } from './item-unidade';

@Component({
    selector: 'sgt-item-unidade',
    templateUrl: './item-unidade.component.html',
    styleUrls: ['./item-unidade.component.less']
})
export class ItemUnidadeComponent implements BaseVisualizacao<ItemUnidade>, OnInit {
    entities: ItemUnidade[];
    dataTable: any;

    constructor(private activatedRoute: ActivatedRoute,
                private baseVisualizacaoService: BaseVisualizacaoService,
                private messageService: MessageService,
                private dataTablesService: DataTablesService,
                private ItemUnidadeCrudHttpService: ItemUnidadeCrudHttpService) { }


    ngOnInit() {
        this.search();
    }

    search() {
        this.ItemUnidadeCrudHttpService.search()
            .subscribe(
                entities => {
                    this.entities = entities;
                    this.showTable();
                },
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as unidades', error)
            );
    }

    showTable() {
        this.dataTablesService.showTable('#tableItensUnidades', this.dataTable)
            .then(dataTable => {
                this.dataTable = dataTable;
                this.baseVisualizacaoService.ativarArmazenamento(this.dataTable, null);
            });
    }

    insert() {
        this.baseVisualizacaoService.insert(this.activatedRoute);
    }

    edit(entity: ItemUnidade) {
        this.baseVisualizacaoService.edit(entity.id, this.activatedRoute);
    }

    delete(entity: ItemUnidade) {
        this.messageService.confirm(`Deseja realmente excluir a unidade: ${entity.nome}?`).then(result => {
            if (result) {
                this.ItemUnidadeCrudHttpService.delete(entity.id)
                    .subscribe(
                        response => {
                            this.messageService.success('', response);
                            this.search();
                        },
                        (error: ApiError) => this.messageService.error(error.message, `Erro ao excluir a unidade: ${entity.nome}`, error)
                    );
            }
        });
    }
}
